import { FC } from 'react';

import type { NoteSurface } from '../lib';

import styles from './NoteDocumentEditor.module.scss';

// What a note shows while its editor loads: the same sections and lines, as
// plain text in the editor's layout, so the editor takes their place
// without the page jumping.
export const NoteDocumentFallback: FC<{ surface: NoteSurface }> = ({
  surface,
}) => (
  <div
    className={styles.editor}
    aria-busy
    data-component="workspace-note-loading"
  >
    {surface.sections.map((section) => (
      <section key={section.id} data-note-section-id={section.id}>
        <div data-note-section-head>
          <h3>{section.title}</h3>
        </div>
        <div data-note-section-lines>
          {section.lines.map((line) => (
            <div key={line.id} data-note-line-id={line.id}>
              {line.text}
            </div>
          ))}
        </div>
      </section>
    ))}
  </div>
);
